import { billingApi } from "services/billingApi"
import { store } from "store/store"
import { logger } from "utils/logger"

const getErrorType = (error: unknown): string => {
  if (error instanceof Error) return error.name
  return "unknown_error"
}

/**
 * Fire-and-forget onboarding activation, called right after a successful
 * product save — the moment "product setup" completes and the 1h onboarding
 * trial must start (Asana 1217267783347632). The backend re-verifies the
 * catalog server-side, and login keeps its own backstop call (Initializer),
 * so a missed call only defers activation — it never blocks the save.
 *
 * The guard keeps every ordinary save of an already-activated (or
 * non-experiment) merchant from pinging billing forever.
 */
export const requestOnboardingActivationAfterProductSetup = (): void => {
  const entitlement = store.getState().billing.entitlement
  if (
    entitlement?.onboardingFlowVariant !== "test" ||
    entitlement.onboardingTrialStatus !== "not_started"
  )
    return

  // markOnboardingActivation syncs the returned entitlement into the store,
  // which re-arms the BillingGate trial-expiry timer with trialEndsAt.
  billingApi.markOnboardingActivation({ suppressPaywall: true }).catch((error: unknown) => {
    logger.warn("billing", "onboarding_activation_failed", {
      errorType: getErrorType(error),
    })
  })
}
